import { Link } from "react-router-dom";
import JsonLd from "@/components/base/JsonLd";
import PageHeader from "@/components/feature/PageHeader";
import ScoopCard from "@/components/feature/ScoopCard";
import useSeo from "@/hooks/useSeo";
import { topics } from "@/mocks/topics";
import { scoops } from "@/mocks/scoops";

const ORIGIN = "https://jyhtdd.cn";

export default function TopicsPage() {
  useSeo({
    title: "热门专题 - 看料爆料｜把零散线索拼成完整脉络",
    description:
      "看料爆料热门专题汇总同类爆料线索，按月与主题串联成完整时间线，涵盖消费避坑、直播带货售后、职场维权与智能硬件问题等方向。",
    keywords: "看料爆料专题,爆料合集,消费避坑,直播带货售后,职场维权,智能硬件问题",
    canonical: `${ORIGIN}/topics`,
  });

  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      name: "看料爆料热门专题",
      url: `${ORIGIN}/topics`,
      inLanguage: "zh-CN",
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "首页", item: `${ORIGIN}/` },
        { "@type": "ListItem", position: 2, name: "热门专题", item: `${ORIGIN}/topics` },
      ],
    },
  ];

  return (
    <>
      <JsonLd data={jsonLd} />
      <PageHeader
        crumbs={[{ label: "首页", to: "/" }, { label: "热门专题" }]}
        eyebrow="热门专题"
        title="让碎片线索，拼成完整的事情全貌"
        desc="单个爆料往往只能看到一个切面。专题按主题把同类线索、时间节点与后续进展串起来，方便你从头理清一件事的来龙去脉。"
      />

      <section className="mx-auto w-full max-w-shell px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {topics.map((topic) => (
            <article
              key={topic.id}
              className="group overflow-hidden rounded-lg border border-foreground-950/10 bg-background-50"
            >
              <div className="flex flex-col sm:flex-row">
                <div className="h-52 w-full shrink-0 sm:h-auto sm:w-48">
                  <img
                    src={topic.cover}
                    alt={`${topic.title} - 看料爆料专题封面`}
                    title={`${topic.title} - 看料爆料`}
                    className="h-full w-full object-cover"
                  />
                </div>
                <div className="flex flex-1 flex-col p-5">
                  <span className="inline-flex w-fit items-center gap-1.5 rounded-full bg-accent-100 px-2.5 py-0.5 text-[11px] font-medium text-accent-900">
                    {topic.tag} · 共 {topic.count} 条
                  </span>
                  <h2 className="mt-3 font-heading text-lg font-bold text-foreground-950">{topic.title}</h2>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{topic.desc}</p>
                  <Link
                    to="/scoops"
                    className="mt-4 inline-flex w-fit items-center gap-1.5 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-800"
                  >
                    查看专题线索
                    <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
                  </Link>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-14">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">专题内的精选线索</h2>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            下面这些条目来自不同专题，都带有明确的核实状态标注，可点击查看完整内容与后续进展。
          </p>
          <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {scoops.slice(0, 6).map((scoop) => (
              <ScoopCard key={scoop.id} scoop={scoop} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}